import { Injectable } from '@angular/core';
import { isTimestamp } from './is-timestamp.util';
import { supportedFileExtensions } from './signed-url/file-upload';

@Injectable({
  providedIn: 'root',
})
export class FileUtilsService {
  public getFileNameWithoutExtension(fileName: string): string {
    let fileNameWithoutExtension: string = fileName;
    if (fileNameWithoutExtension.indexOf('.') > -1) {
      fileNameWithoutExtension = fileNameWithoutExtension.substring(0, fileNameWithoutExtension.lastIndexOf('.'));
    }
    return fileNameWithoutExtension;
  }

  public getFileExtension(fileName: string): string {
    let fileExtension: string = '';
    if (fileName.indexOf('.') > -1) {
      fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
    }
    return fileExtension;
  }

  public isFileExtension(filename: string, extension: string): boolean {
    if (filename) return filename.toLowerCase().endsWith(extension.toLowerCase());
    return false;
  }

  public getFileDisplayName(name: string): string {
    if (!name) {
      return '';
    }
    const ext: string = name.split('.').length > 1 ? name.split('.').pop() : '';
    const nameArr: string[] = name.split('_');
    const isTime: boolean = isTimestamp(nameArr.pop()?.split('.')[0]); // Use the imported utility
    let savedName: string = '';
    if (isTime) {
      savedName = nameArr.length > 0 ? nameArr.join('_') : name.split('.')[0];
    } else {
      const nameParts: string[] = name.split('.');
      savedName = nameParts.length > 1 ? nameParts.slice(0, -1).join('.') : name;
    }
    return savedName.replace(/[^a-zA-Z0-9-] /g, '_') + (ext && ext !== 'undefined' ? '.' + ext : '');
  }

  public formatSizeInMB(sizeInBytes: number | null | undefined): string {
    if (!sizeInBytes || sizeInBytes === 0) return '0 MB';

    const sizeInMB: number = sizeInBytes / (1024 * 1024);
    return `${sizeInMB.toFixed(2)} MB`;
  }

  public filterFilesToUpload(files: File[]): File[] {
    const supportedFiles: File[] = [];

    for (const file of files) {
      const extension: string = this.getFileExtension(file.name)?.toLowerCase();
      if (supportedFileExtensions.includes(extension)) {
        supportedFiles.push(file);
      } else {
        const typeExt: string = file.type.split('/').pop();
        const extensionMap: Record<string, string> = {
          'vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
          'vnd.ms-powerpoint': 'ppt',
          'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
          'vnd.ms-excel': 'xls',
          'vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
          msword: 'doc',
          'application/msword': 'doc',
        };
        if (extensionMap[typeExt]) {
          // Creating a new File object with a corrected name for office documents
          const newFile: File = new File([file], file.name + (typeExt ? '.' + extensionMap[typeExt] : ''), {
            type: file.type,
          });
          supportedFiles.push(newFile);
        }
      }
    }

    return supportedFiles;
  }

  public copyFilePropsAfterScanning(source: Record<string, any>, target: Record<string, any>): void {
    const props: string[] = ['malwareScanningStatus', 'metadata', 'transcodeMetadata', 'hasPage'];
    props.forEach((prop: string) => {
      if (source[prop]) {
        target[prop] = source[prop];
      }
    });
  }
}
